import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import KyrgyzstanOnboardingImage from 'shared/images/kyrgyzstan_onboarding.webp'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface OnboardingProps {
  onClose?: () => void
  onStart?: () => void
}

export const Onboarding: FC<OnboardingProps> = ({ onClose, onStart }) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('safe-area-top-padding', s.container)}>
      <img
        src={KyrgyzstanOnboardingImage}
        alt={t('kyrgyzstan_block.onboarding.title')}
        className={s.background}
        loading="eager"
      />

      <div className={s.overlay} />

      <button
        className={s.closeButton}
        onClick={onClose}
      >
        <AppIcon
          id={AllIcons.CROSS}
          width={24}
          height={24}
          color="var(--white)"
        />
      </button>

      <div className={s.content}>
        <h1 className={clsx('extra-bold-24', s.title)}>
          {t('kyrgyzstan_block.onboarding.title')}
        </h1>

        <p className={clsx('medium-14', s.subtitle)}>
          {t('kyrgyzstan_block.onboarding.subtitle')}
        </p>

        <Button
          className={s.startButton}
          onClick={onStart}
        >
          <span className={clsx('semi-bold-17', s.buttonText)}>
            {t('kyrgyzstan_block.onboarding.start_button')}
          </span>
        </Button>
      </div>
    </div>
  )
}
